function getBase(state) {
  return state.ui.timelineShow
}

export function getEmbedKeyLoadStatus(state, props) {
  return getBase(state).embedKeyLoadStatus
}
